import { Subject } from 'rxjs';
var ObservableModel = /** @class */ (function () {
    function ObservableModel(initialValue) {
        this.subject = new Subject();
        this.value = initialValue || null;
    }
    ObservableModel.prototype.getValue = function () {
        if (!this.value) {
            throw new Error('ObservableModel error: value is empty, you must set current value before call "getValue"');
        }
        return this.value;
    };
    ObservableModel.prototype.update = function (nextValue) {
        this.value = nextValue;
        this.subject.next(nextValue);
    };
    ObservableModel.prototype.asObservable = function () {
        return this.subject.asObservable();
    };
    return ObservableModel;
}());
export { ObservableModel };
//# sourceMappingURL=ObservableModel.js.map